import { Breadcrumb as BaseBreadcrumb, theme } from 'antd';
import styled from 'styled-components';

const { colorText } = theme.getDesignToken();

export const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  padding-right: 20px;

  .ant-breadcrumb {
    font-size: 19px;
  }

  .ant-breadcrumb-item,
  .ant-breadcrumb-item a {
    color: ${colorText};
  }

  .ant-breadcrumb-item:last-child {
    font-weight: 600;
  }

  .ant-btn {
    &.selected {
      background: #a8a8a8;
      border-color: #989696;
      color: white;
    }
  }
`;

export const BreadcrumbContainer = styled.div``;

export const Breadcrumb = styled(BaseBreadcrumb)`
  line-height: 20px;
`;
